/*!

=========================================================
* Argon Dashboard React - v1.2.3
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// reactstrap components
import { Row } from 'reactstrap';
import { GlobalContext } from '../api/GlobalContext';
import { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const TEST_HOSTNAME = 'dev.comprhendpt.com';
const TEST_TABLE_ID = 'prctbl_1NvJtSJn3ZKFBtM1LoNl77PB';
export const TEST_PUBLISHABLE_KEY =
  'pk_test_51NEf9pJn3ZKFBtM1boOt6jVMtIZEXdscnBFykREwgiaQta7Gl0fPLFS1jNxKdnzaDWljNzPf2apunWAFh8OlRRLK00JGKoNjBW';

const FORMAL_TABLE_ID = 'prctbl_1Nv2SgJn3ZKFBtM1FRqU2HP9';
export const FORMAL_PUBLISHABLE_KEY =
  'pk_live_51NEf9pJn3ZKFBtM1ieBmTR7abF0kuRGGKLbbOvDFsvlTGryqFDFcUBPBkgWGnarK1rzcLjp4DXMJAYhpgC623Zb300QuheIFCi';

const Subscriptions = () => {
  // Add Logic for Free Trial that Gives them 5 conversations
  // Forward user to Subscription page if they are expired
  // TODO get the email from the API in the about
  // Reject New Conversation if the expiration is too far out
  // Add Stripe to Lambda, setting expiration date

  const navigate = useNavigate();

  // Get our Globals
  const { apiClient } = useContext(GlobalContext);

  const [sessionKey, setSessionKey] = useState(apiClient.sessionKey);
  const [email, setEmail] = useState(apiClient.email);
  const [subscription, setSubscription] = useState(apiClient.subscription);
  const [expiration, setExpiration] = useState(apiClient.expiration);

  const hostname = window.location.hostname;
  const [tableID, setTableID] = useState(
    hostname === TEST_HOSTNAME ? TEST_TABLE_ID : FORMAL_TABLE_ID,
  );
  const [publishableKey, setPublishableKey] = useState(
    hostname === TEST_HOSTNAME ? TEST_PUBLISHABLE_KEY : FORMAL_PUBLISHABLE_KEY,
  );

  useEffect(() => {
    // Go get the user's email
    apiClient
      .updateProfile()
      .then((data) => {
        setExpiration(apiClient.expiration.match(/\d{4}-\d{2}-\d{2}/)[0]);
        setSubscription(apiClient.subscription);
        setEmail(apiClient.email);
      })
      .catch((error) => {
        // probably no session key
        console.log(error);
      });

    // Load the external script when the component mounts
    const script = document.createElement('script');
    script.src = 'https://js.stripe.com/v3/pricing-table.js';
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <>
      {/* Page content */}
      {/* Table */}
      <Row>
        <div className="col">
          {subscription === 'FREE_TRIAL' && (
            <stripe-pricing-table
              pricing-table-id={tableID}
              publishable-key={publishableKey}
              client-reference-id={sessionKey}
              customer-email={email}
            ></stripe-pricing-table>
          )}
          {subscription !== 'FREE_TRIAL' &&
            expiration &&
            window.location.pathname === '/User/settings' && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  margin: '10px',
                }}
              >
                <p style={{ marginLeft: '10px', fontWeight: 'bold' }}>
                  Expires on: {expiration}
                </p>
              </div>
            )}
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              margin: '10px',
            }}
          >
            <a
              href={`https://billing.stripe.com/p/login/9AQg1d67P5rjcik6oo?prefilled_email=${email}`}
              className="btn btn-primary"
            >
              Manage Account
            </a>
          </div>
        </div>
      </Row>
    </>
  );
};

export default Subscriptions;
